// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__318AY","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3EJfv"};